import React from 'react';
import { Provider } from 'react-redux';
import * as analytics from './app/applicationServices/analytics';
import * as acceptCookies from './app/acceptCookies';
import Routes from './routes';
import configureStore from './store';

export const store = configureStore();

const Root = () => (
  <Provider store={store}>
    {Routes(analytics.onRouteUpdate(store, acceptCookies))}
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/root.jsx